import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchApi } from '../config/api';
import { LogIn } from 'lucide-react';
import { Alert, PageBackdrop, PageHeader } from '../components/UI';
import { useAuth } from '../context/AuthContext';

const JoinBreedingStation: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [inviteCode, setInviteCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccessMessage('');

    try {
      const result = await fetchApi('/breeding-stations/join', {
        method: 'POST',
        body: JSON.stringify({ inviteCode: inviteCode.trim() })
      });
      setSuccessMessage(t('breedingStation:join.successMessage', { name: result.name }));
      // Als Mitglied gibt es neue Menuepunkte (z.B. Interessenten) - Nutzer neu laden, damit sie sofort erscheinen.
      refreshUser().catch(() => {
        // Best-effort: spaetestens beim naechsten Laden der App stimmt das Menue.
      });
      setTimeout(() => navigate('/dashboard'), 1000);
    } catch (err: any) {
      setError(err.message || t('breedingStation:join.errorMessage'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <PageBackdrop />

      <div className="relative z-10 container mx-auto px-4 py-8 sm:px-6 sm:py-10">
        <PageHeader
          title={t('breedingStation:join.title')}
          subtitle={t('breedingStation:join.subtitle')}
          backLink={{ label: t('nav:primary.cockpit'), onClick: () => navigate('/dashboard') }}
        />

        <main className="mt-6">
          <div className="card max-w-md">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="label-base" htmlFor="inviteCode">{t('breedingStation:join.codeLabel')}</label>
                <input
                  className="input-base font-mono uppercase tracking-widest"
                  type="text"
                  id="inviteCode"
                  name="inviteCode"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value)}
                  required
                  placeholder={t('breedingStation:join.codePlaceholder')}
                  maxLength={16}
                />
              </div>

              {error && <Alert type="error" message={error} />}
              {successMessage && <Alert type="success" message={successMessage} />}

              <div className="form-actions">
                <button type="submit" className="btn btn-primary" disabled={loading || !inviteCode.trim()}>
                  <LogIn size={18} />
                  {loading ? t('breedingStation:join.joining') : t('breedingStation:join.submit')}
                </button>
                <button type="button" className="btn btn-ghost" onClick={() => navigate('/dashboard')}>
                  {t('common:actions.cancel')}
                </button>
              </div>
            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default JoinBreedingStation;
